import React, { useState, useEffect } from 'react';
import '../../css/shared/Header.css';
import { useSelector } from 'react-redux';
import Cookies from 'cookies-js';
import { AES, enc } from 'crypto-js';
import { logoutPath, invalidTokenPath } from '../../Services/config/apiGateway';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
toast.configure()
function Header() {
  const [dropdown, setdropdown] = useState(false);
  const container = React.createRef();
  const loginData = useSelector(state => JSON.parse(AES.decrypt(state.authentication.user, 'TPT_CARGO_CONNECT').toString(enc.Utf8)));
  const firstname = loginData.userDetails.userdetails.user.firstName;
  const lastname = loginData.userDetails.userdetails.user.lastName;
  const toggleDropdown = () => {
    setdropdown(!dropdown);
  }
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
  })
  const handleClickOutside = event => {
    if (container.current && !container.current.contains(event.target)) {
      setdropdown(false);
    }
  };
  const dashboardNavigate = () => {
    window.location.replace("/")
  };
  const handleLogOut = () => {
    let testAccess = Cookies.get('msAL_admin_dev');
    testAccess= JSON.parse(AES.decrypt(testAccess, 'itsEncrypted1').toString(enc.Utf8))
    fetch(invalidTokenPath, {
    // fetch(`https://tpt-apim-cargo-dev.azure-api.net/cc-admin-user-management/v1/Invalidationoftokens`, {
      // fetch(`https://tpt-apim-cargo-test.azure-api.net/cc-admin-user-management/v1/Invalidationoftokens`, {
      method: 'GET',
      headers: {
        // 'Authorization': 'Bearer ' + Cookies.get('msAL_admin_dev'),
        'Authorization': 'Bearer ' + testAccess,
        'refresh_token': Cookies.get('msAL_adminRef_dev')
      }
    })
      .then(res => {
        return res;
      })
      .then(data => {
        Cookies.expire('msAL_admin_dev');
        Cookies.expire('msAL_adminRef_dev');
        localStorage.clear();
        sessionStorage.clear();
        window.location.replace(logoutPath)
        // window.location.replace('https://tpt-apim-cargo-dev.azure-api.net/ccLoginAdmin/v1/ccAdminLogout?post_logout_redirect_uri=https://www.dev-cargoconnectadmin.transnetportterminals.net')
        // window.location.replace('https://tpt-apim-cargo-test.azure-api.net/ccLoginAdmin/v1/ccAdminLogout?post_logout_redirect_uri=https://www.test-cargoconnectadmin.transnetportterminals.net')
      });
  }
  return (
    <nav className="navbar fixed-top navbar-white bg-white shadow-sm" id="headerContainer">
      <a className="navbar-brand" >
        <img src={require('../../assets/images/companyLogo.svg')} width="185" height="35" class="d-inline-block align-top pl-4" alt="" loading="lazy" onClick={dashboardNavigate} />
      </a>
      <div>
        <div class="pr-3" id="headerimgdiv">
          <img src={require('../../assets/images/headerProfile.svg')} width="35" height="35" class="d-inline-block align-top" alt="" loading="lazy" />
          <div class="pt-1 pr-1 pl-1">
            <a>
              <small class="p-1" id="headerpersonname">{firstname + " " + lastname}</small>
            </a>
          </div>
          <img src={require('../../assets/images/profile_drpdwnArrow.svg')} onClick={toggleDropdown} width="13" height="13" class="d-inline-block pt-1" alt="" loading="lazy" />
        </div>
        {dropdown && (
          <div class="border" id="headerDropdown" ref={container} >
            <a class="pb-2 pr-4" onClick={handleLogOut}>
              <small class="p-2" id="headersignout">Sign Out</small>
            </a>
          </div>
        )}
      </div>
    </nav>
  );
}
export default Header;